import type {
  ComponentPropsWithRef,
  ComponentPropsWithoutRef,
  ReactNode,
} from 'react';

import classNames from 'classnames';

import styles from './InlineStyledSelect.module.css';

import { ChevronAccordion } from '../../icons/ChevronAccordion';

type InlineStyledSelectProps = {
  label: string;
  labelProps: ComponentPropsWithoutRef<'label'>;
  selectedLabel: ReactNode;
  toggleButtonProps: ComponentPropsWithRef<'button'>;
  isOpen: boolean;
  className?: string;
  children: ReactNode;
};

export function InlineStyledSelect({
  label,
  labelProps,
  selectedLabel,
  toggleButtonProps,
  isOpen,
  className,
  children,
}: InlineStyledSelectProps) {
  return (
    <div className={classNames(styles.container, className)}>
      <label {...labelProps} className={styles.label}>
        {label}
      </label>
      <button {...toggleButtonProps} className={styles.button} type="button">
        <span className={styles.value}>{selectedLabel ?? label}</span>
        <ChevronAccordion
          aria-hidden
          orientation={isOpen ? 'up' : 'down'}
          size={16}
          baseColor="Sage700"
        />
      </button>
      {children}
    </div>
  );
}
